import "core-js/modules/es.object.assign.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx } from "react/jsx-runtime";
import { assert } from "@/common/assert";
import { formatChatStatus } from "../chatRoomUtils";
export default function ChatStatusMessageItem(props) {
  var customAttrs = props.message.customAttrs;
  assert(customAttrs, "gotta have body");
  var displayText = formatChatStatus(customAttrs, props.message.myself);
  return _jsx("div", {
    children: displayText && displayText.length > 0 && _jsx("span", __assign({
      className: "chat-message-item__status"
    }, {
      children: _jsx("span", __assign({
        className: "chat-message-item__status-inner"
      }, {
        children: displayText
      }), void 0)
    }), void 0)
  }, void 0);
}